import { ModalityPage } from "../../../../Data/ModalityPage"
import { getTimeSeriesData, TimeSeriesData } from "../../../../Data/TimeSeriesData"
import { LineStepRenderStrategy } from "./D3LineStepRenderStrategy"

export class InfusionMedicationRenderStrategy extends LineStepRenderStrategy {
    protected isMissingValue = (value: number | null) => value === null || value <= 0

    protected getLineWidth(): number {
        return 3
    }
    
    protected *drawableDataGenerator(timeSeriesData: TimeSeriesData, page: ModalityPage): Generator<[number | undefined, number | undefined], void, undefined> {
        const samplingPeriod = page.timingInformation.get(this.d3Trace.dataObjectId)?.get(this.config.dataKey)?.samplingPeriod ?? Infinity
        const previousPageData = this.pageManager.getPreviousPage(page)?.data.get(this.dataObjectId)?.get(this.config.dataKey)
        const nextPageData = this.pageManager.getNextPage(page)?.data.get(this.dataObjectId)?.get(this.config.dataKey)

        if (previousPageData) {
            const previousPageTimeSeriesData = getTimeSeriesData(previousPageData, this.config)
            if (previousPageTimeSeriesData.data.length > 0) {
                const previousValue = previousPageTimeSeriesData.data[previousPageTimeSeriesData.data.length-1]
                const previousTime = previousPageTimeSeriesData.times[previousPageTimeSeriesData.times.length-1]
                
                // Check for a gap in times or NaN value
                if (timeSeriesData.times.length > 0 && timeSeriesData.times[0] - previousTime <= 1.05 * samplingPeriod && !Number.isNaN(previousValue)) {
                    yield [previousTime, previousValue]
                }
            }
        }
        
        for (let i = 0; i < timeSeriesData.data.length; i++) {
            if (this.isMissingValue(timeSeriesData.data[i])) {
                if (i > 0 && !this.isMissingValue(timeSeriesData.data[i-1])) {
                    yield [timeSeriesData.times[i], timeSeriesData.data[i-1]]
                }
                yield [undefined, undefined]
            } else {
                yield [timeSeriesData.times[i], timeSeriesData.data[i]]
            }
        }

        if (nextPageData) {
			const nextPageTimeSeriesData = getTimeSeriesData(nextPageData, this.config)
			if (nextPageTimeSeriesData.data.length > 0) {
				const nextValue = nextPageTimeSeriesData.data[0]
				const nextTime = nextPageTimeSeriesData.times[0]

				// Check for a gap in times or NaN value
				if (timeSeriesData.times.length > 0 && nextTime - timeSeriesData.times[timeSeriesData.times.length-1] <= 1.05 * samplingPeriod && !Number.isNaN(nextValue)) {
					yield [nextTime, nextValue]
				}
			}
		}
    }
}